import React, { useEffect, useRef } from 'react';
import './HubSpotFormEmbed.css';

const FORMS_SCRIPT_URL = '//js.hsforms.net/forms/v2.js';
const CONTAINER_ID = 'hubspot-form-container';

const DEFAULT_PORTAL_ID = '25608636';
const DEFAULT_FORM_ID = 'fa9ddb0c-da6a-4b9d-9020-b9d81aa3d757';

/**
 * Embeds a HubSpot form via hbspt.forms.create().
 * Use when country is UK on /uk/start to replace the previous registration form.
 * portalId and formId are fixed defaults; pass props to override.
 */
function HubSpotFormEmbed({
  portalId: portalIdProp = DEFAULT_PORTAL_ID,
  formId: formIdProp = DEFAULT_FORM_ID,
  region = 'eu1',
  target = `#${CONTAINER_ID}`,
  cssClass,
  submitButtonClass,
}) {
  const createdRef = useRef(false);

  const portalId = portalIdProp;
  const formId = formIdProp;

  useEffect(() => {
    if (!portalId || !formId) return;

    const createForm = () => {
      if (typeof window.hbspt === 'undefined' || createdRef.current) return;
      if (!document.getElementById(CONTAINER_ID)) return;
      createdRef.current = true;
      window.hbspt.forms.create({
        portalId: String(portalId),
        formId: String(formId),
        target,
        region,
        cssClass,
        submitButtonClass,
      });
    };

    if (window.hbspt) {
      createForm();
      return;
    }

    const existing = document.querySelector('script[src*="js.hsforms.net"]');
    if (existing) {
      existing.addEventListener('load', createForm);
      if (document.readyState === 'complete') createForm();
      return () => existing.removeEventListener('load', createForm);
    }

    const script = document.createElement('script');
    script.src = FORMS_SCRIPT_URL;
    script.charset = 'utf-8';
    script.async = true;
    script.addEventListener('load', createForm);
    document.body.appendChild(script);

    return () => script.removeEventListener('load', createForm);
  }, [portalId, formId, region, target, cssClass, submitButtonClass]);

  return (
    <div
      id={CONTAINER_ID}
      className={[
        'px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:flex lg:items-center',
        cssClass,
      ].filter(Boolean).join(' ')}
    />
  );
}

export default HubSpotFormEmbed;
